<template>
  <button
    class="button +green +large text-base! w-full"
    data-gtm-category="product page"
    data-gtm-action="add to cart"
    :data-gtm-label="gtmLabel"
    :disabled="$cart.loading === 'add'"
  >
    <loader v-if="$cart.loading === 'add'" />
    <div v-else>
      {{ $t('action.add_to_box') }}
      <div
        class="rounded-full absolute right-3 top-3 text-sm p-1 w-[56px] bg-green-600"
      >
        ${{ Number(cents) / 100 }}
      </div>
    </div>
  </button>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { Variant } from '@/types/shopify'
import Loader from '@/components/shared/loader.vue'
export interface Props {
  variant: Variant
  price?: number
  gtmLabel?: string
}
const props = defineProps<Props>()
const cents = computed<string | number>(() => typeof props.price === 'number' ? props.price : props.variant?.price)
</script>
